import { createSelector } from '../reselect';
import { getNewStats, total, simpleChart, safeDivide } from '../generalUtils';

const providerId = 'shipstation';

const shipstationShipments = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'shipments')
);
const shipstationShipmentsChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'shipments')
);

const shipstationCost = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'shipments_cost')
);
const shipstationCostChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'shipments_cost')
);

const shipstationOrders = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'orders')
);
const shipstationOrdersChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'orders')
);

const shipstationOrdersShipped = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'shipped_orders')
);
const shipstationOrdersShippedChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'shipped_orders')
);

const shipstationOrdersUnshipped = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'unshipped_orders')
);
const shipstationOrdersUnshippedChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'unshipped_orders')
);

const shipstationEstimation = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'estimation')
);
const shipstationEstimationChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'estimation')
);

const shipstationAvgCostPerShipment = createSelector(
  [shipstationCost, shipstationShipments],
  (shipstationCost, shipstationShipments) => {
    return safeDivide(shipstationCost, shipstationShipments);
  }
);
const shipstationAvgCostPerShipmentChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'avg_cost_per_shipment')
);

const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    shipstationCost,
    shipstationCostChart,

    shipstationShipments,
    shipstationShipmentsChart,

    shipstationOrders,
    shipstationOrdersChart,

    shipstationOrdersShipped,
    shipstationOrdersShippedChart,

    shipstationOrdersUnshipped,
    shipstationOrdersUnshippedChart,

    shipstationAvgCostPerShipment,
    shipstationAvgCostPerShipmentChart,

    shipstationEstimation,
    shipstationEstimationChart,
  },
};
